import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import {UPDATE_NATURE_MAGAZINE_ERROR, UPDATE_NATURE_MAGAZINE_START, UPDATE_NATURE_MAGAZINE_SUCCESS} from "../../types";

export function* update({payload}) {
    try {
        const url = `/natura_magazines/${payload.formData.id}/`;
        const method = 'PUT';
        const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'multipart/form-data'};
        const data = (object) => Object.keys(object).reduce((formData, key) => {
            formData.append(key, object[key]);
            return formData;
        }, new FormData());
        const results = yield call(apiCall, url, method, data(payload.formData), headers);
        yield put({type: UPDATE_NATURE_MAGAZINE_SUCCESS, results: results.data});
        yield put(payload.navigate('/app/content-management/manage-nature-magazine'))
    } catch (error) {
        yield put({type: UPDATE_NATURE_MAGAZINE_ERROR, error});
    }
}

export default function* update_nature_magazine() {
    yield takeLatest(UPDATE_NATURE_MAGAZINE_START, update);
}